// extracted by mini-css-extract-plugin
export default {"shell":"page-shell_shell__QMVSP"};